export const handleKeyPress = (event, callback) => {
  if (event.key === "Enter" || event.key === " ") {
    callback?.();
  }
};
